import { Color } from '@diritto/common/style/color';

export const KakaoLoginIcon = ({ color = Color.Black }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3464 3C7.04641 3 2.75049 6.33399 2.75049 10.45C2.75049 13.0067 4.41199 15.2636 6.94224 16.6052L5.87758 20.5124C5.78363 20.8589 6.17657 21.1322 6.47844 20.9323L11.1451 17.838C11.5389 17.8758 11.9392 17.898 12.3464 17.898C17.6461 17.898 21.9422 14.5616 21.9422 10.45C21.9422 6.33399 17.6461 3 12.3464 3Z"
      fill={color}
    />
  </svg>
);
